import React from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";
import { useNavigate } from "react-router";

export interface DialogProps {
    open: boolean;
    title: string;
    text: string;
    onClose: () => void;
}

const Dialog = ({open, title, text, onClose}: DialogProps) => {
    const [t] = useTranslation();
    const navigate = useNavigate();

    const close = () => {
        onClose();
    }

    const goToMenu = () => {
        navigate("/menu#ns");
    }

    if (!open)
        return null;

    return <div className="Dialog">
        <div className="dialogContainer">
            <div className="textContent">
                <div className="title">{title}</div>
                <div className="text">{text}</div>
            </div>
            <div className="buttons">
                <div className="button dark yes" onClick={goToMenu}>{t("yes")}</div>
                <div className="button no" onClick={close}>{t("no")}</div>
            </div>
        </div>
    </div>
}

export default Dialog;